import useMobileObserver from './useMobileObserver';
export default function (benefits, _ref) {
  var _ref$mobile = _ref.mobile,
    mobile = _ref$mobile === void 0 ? Infinity : _ref$mobile,
    _ref$desktop = _ref.desktop,
    desktop = _ref$desktop === void 0 ? 1 : _ref$desktop,
    _ref$showOnlyOnHover = _ref.showOnlyOnHover,
    showOnlyOnHover = _ref$showOnlyOnHover === void 0 ? false : _ref$showOnlyOnHover;
  var _useMobileObserver = useMobileObserver(),
    isMobile = _useMobileObserver.isMobile;
  var wrapAround = false;
  var draggable = computed(function () {
    return isMobile.value;
  });
  var prevNextButtons = computed(function () {
    var _benefits$value, _benefits$value2;
    return isMobile.value ? ((_benefits$value = benefits.value) === null || _benefits$value === void 0 ? void 0 : _benefits$value.length) > mobile : ((_benefits$value2 = benefits.value) === null || _benefits$value2 === void 0 ? void 0 : _benefits$value2.length) > desktop;
  });
  var hoverClass = showOnlyOnHover ? 'show-buttons-on-hover' : '';
  var props = computed(function () {
    return {
      prevNextButtons: prevNextButtons.value,
      draggable: draggable.value,
      wrapAround: wrapAround,
      class: hoverClass
    };
  });
  return props;
}